
<v-hover v-slot="{ hover }" open-delay="200" >
    <div class="app-side-buttons" style="margin-top: 55px" >
        <v-scale-transition>
            <div v-show="hover || permanent || history">
                <c-menu-button
                    v-if="!readonly && isEditAllowed && (!history || historyEditable) && !download"
                    label      = "unit.edit.menu.edit"
                    icon       = "mdi-pen"
                    icon-color = "primary--text"
                    @click     = "onReadonly"
                />

                <c-menu-button
                    v-if="readonly && isEditAllowed && (!history || historyEditable) && !download"
                    label      = "unit.edit.menu.readonly"
                    icon       = "mdi-eye-outline"
                    icon-color = "primary--text"
                    @click     = "onReadonly"
                />

                <c-menu-button
                    v-if="!readonly && isEditAllowed && (!history || historyEditable)"
                    label      = "unit.edit.menu.save"
                    icon       = "mdi-content-save-outline"
                    icon-color = "primary--text"
                    @click     = "onSave"
                />

                <c-menu-button
                    label      = "unit.edit.menu.refresh"
                    icon       = "mdi-refresh"
                    icon-color = "primary--text"
                    @click     = "onRefresh"
                />

                <c-menu-button
                    label      = "unit.edit.menu.close"
                    icon       = "mdi-close"
                    icon-color = "primary--text"
                    @click     = "onClose"
                />

                <c-menu-button
                    v-if       = "history"
                    label      = "unit.edit.menu.history"
                    icon       = "mdi-history"
                    icon-color = "primary--text"
                    @click     = "onHistory"
                />

                <c-menu-button
                    v-if       = "reports"
                    label      = "unit.edit.menu.reports"
                    icon       = "mdi-printer"
                    icon-color = "primary--text"
                    @click     = "onReports"
                />

                <c-menu-button
                    v-if       = "condition"
                    label      = "unit.tzb.budget.title"
                    icon       = "mdi-calculator"
                    icon-color = "primary--text"
                    @click     = "onExtendedConditions"
                />
            </div>
       </v-scale-transition>
    </div>
</v-hover>
